// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","tablet":"(max-width: 1024px)","container":"container-2A_dW","title":"title-NSAcE","services":"services-16n2g"};